import { AUTHORIZATION_HEADER } from '../../../../../../../src/authorization';
import { send } from '../../../../../../../src/network';

export type DeleteFavoriteProductResponse = unknown;

export type DeleteFavoriteProductParams = {
  customerId: number;
  productId: number;
};

export function deleteFavoriteProductPath({
  customerId,
  productId,
}: DeleteFavoriteProductParams) {
  return `/api/v2/customers/${customerId}/favorite_products/${productId}`;
}

export async function deleteFavoriteProduct({
  customerId,
  productId,
}: DeleteFavoriteProductParams) {
  return await send<DeleteFavoriteProductResponse>({
    path: deleteFavoriteProductPath({ customerId, productId }),
    method: 'DELETE',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
